<template>
	<CDialog
		:visible="visible"
		:title="title"
		custom-class="dialog--tiny organization-settings-plan exit-agreement-dialog"
		@done="$emit('close')"
	>
		<slot name="content" />

		<template #footer>
			<button
				class="c-modal-button c-modal-button-cancel button--secondary"
				@click="$emit('close')"
			>
				Cancel
			</button>
			<CStatusButton
				:status="status"
				class="c-modal-button button--primary"
				@click="status = 'validating'; $emit('handle-exit');"
			>
				Exit Agreement
			</CStatusButton>
		</template>
	</CDialog>
</template>

<script lang="ts">
	import { defineComponent } from 'vue';
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import CStatusButton from 'src/components/interaction/StatusButton.vue';

	export default defineComponent({
		name: 'CExitAgreementDialog',
		components: {
			CDialog,
			CStatusButton
		},
		props: {
			visible: { type: Boolean, default: false },
			title: { type: String, default: '' }
		},
		data() {
			return {
				status: 'default'
			};
		}
	});
</script>